import {Component, Input} from '@angular/core';
import {ApiService} from "../../services/api.service";
import {FeedbackService} from "../../services/feedback.service";
import {PopupService} from "../../services/popup.service";

@Component({
  selector: 'feature-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent {
  @Input() feedbackElement: string;
  @Input() searchId: number;
  @Input() setElement: Function;

  public feedbackProvided: boolean = false;


  constructor(
    private feedbackService: FeedbackService,
    private popupService: PopupService,
  ){

  }

  ngOnInit(): void {
    this.feedbackProvided = false;
  }

  vote(helpful: boolean){
    this.feedbackService.feature_feedback({
      useful: helpful,
      feature_name: this.feedbackElement,
      search_id: this.searchId
    }).then(success => {
      if(success.data.status){
        this.popupService.notify("Your feedback has been registed!", "Thank you!", "success");
        this.feedbackProvided = true;
      }
    }).catch(error => {
      this.popupService.notify("There has been an error trying to submit your feedback. Please try again", "Oups!", "error");
    });
  }

  provideFeedback(){
    this.setElement(this.feedbackElement);
  }
}
